import { Token } from '../token.class';
/**
 * Thrown when requested service was not found.
 *
 * @group Errors
 */
export class ServiceNotFoundError extends Error {
    get message() {
        return (`Service with "${this.normalizedIdentifier}" identifier was not found in the container. ` +
            `Register it before usage via explicitly calling the "Container.set" function or using the "@Service()" decorator.`);
    }
    constructor(identifier) {
        super();
        this.name = 'ServiceNotFoundError';
        /** Normalized identifier name used in the error message. */
        this.normalizedIdentifier = '<UNKNOWN_IDENTIFIER>';
        if (typeof identifier === 'string') {
            this.normalizedIdentifier = identifier;
        }
        else if (identifier instanceof Token) {
            this.normalizedIdentifier = `Token<${identifier.name || 'UNSET_NAME'}>`;
        }
        else if (identifier && (identifier.name || identifier.prototype?.name)) {
            this.normalizedIdentifier = `MaybeConstructable<${identifier.name ?? identifier.prototype?.name}>`;
        }
    }
}
//# sourceMappingURL=service-not-found.error.js.map